import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-12 px-4" data-id="element-103">
      <div className="max-w-xl mx-auto text-center" data-id="element-104">
        <div className="text-6xl mb-4" data-id="element-105">🛡️</div>
        <h2 className="text-2xl sm:text-3xl font-black text-[#00C853] mb-4" data-id="element-106">
          GARANTÍA PROFEPACK™ — 7 DÍAS
        </h2>

        <div className="bg-[#000d08] border border-[#00C853]/50 rounded-xl p-6 mb-4" data-id="element-107">
          <p className="text-white text-sm sm:text-base mb-4 leading-snug" data-id="element-108">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en el club si
            querés. Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#00C853] text-2xl font-black mb-2" data-id="element-109">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-sm sm:text-base font-bold" data-id="element-110">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-xs sm:text-sm" data-id="element-111">
          La confianza en nuestro sistema nos permite hacer esta promesa. Tasa
          de devoluciones menor al 1%.
        </p>
      </div>
    </section>;
}